import React, { Component } from "react"
import "./ActionButton.scss"
import ReactTooltip from "react-tooltip"
import { Spinner } from 'components/Loaders/Loaders'
import shortid from 'shortid'

export default class ActionButton extends Component {
  tooltipId = shortid.generate()
  handleClick = e => {
    e.stopPropagation()
    this.props.onClick(e)
  }
  render() {
    const {
      iconClass = "",
      label,
      flex = true,
      className = "",
      tooltip = false,
      hideLabel = false,
      style = "outer",
      disabled = false,
      children,
      loading
    } = this.props
    return (
      <div
        className={`action-button ${flex ? "flex" : ""} ${className} ${style}`}
        data-tip={typeof tooltip === 'string' ? tooltip : label}
        data-for={this.tooltipId}
        // data-delay-show={200}
      >
        <span>
          <button
            className={`action-icon ${iconClass} ${style}`}
            onClick={this.handleClick}
            disabled={disabled}
            aria-label={label}
          >
            {!hideLabel && style === "inner" && label}
            {
              children &&
              <div className="inner-wrapper">
                {
                  loading ?
                  <Spinner size="medium" linear themeColor="medium-neutral"/>
                  :
                  children
                }
              </div>
            }
          </button>
          {!hideLabel &&
            style === "outer" && <span className="label">{label}</span>}
          {tooltip && <ReactTooltip effect="solid" id={this.tooltipId} />}
        </span>
      </div>
    )
  }
}

export class ActionButtonGroup extends Component {
  render() {
    const { className = "", buttonSize = "", children } = this.props
    const numChildren = React.Children.toArray(children).length
    return (
      numChildren > 0 ?
      <div
        className={"action-button-group flex " + className + " " + buttonSize}
      >
        {children}
      </div>
      : null
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ActionButton/ActionButton.js